/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GgFunctionScore } from './GgFunctionScore';
import {
    GgFunctionScoreFromJSON,
    GgFunctionScoreFromJSONTyped,
    GgFunctionScoreToJSON,
    GgFunctionScoreToJSONTyped,
} from './GgFunctionScore';

/**
 * 
 * @export
 * @interface MedicareGgScores
 */
export interface MedicareGgScores {
    /**
     * 
     */
    eating?: Array<GgFunctionScore>;
    /**
     * 
     */
    oral_hygiene?: Array<GgFunctionScore>;
    /**
     * 
     */
    toileting?: Array<GgFunctionScore>;
    /**
     * 
     */
    bed_mobility?: Array<GgFunctionScore>;
    /**
     * 
     */
    transfer?: Array<GgFunctionScore>;
    /**
     * 
     */
    walking?: Array<GgFunctionScore>;
}

/**
 * Check if a given object implements the MedicareGgScores interface.
 */
export function instanceOfMedicareGgScores(value: object): value is MedicareGgScores {
    return true;
}

export function MedicareGgScoresFromJSON(json: any): MedicareGgScores {
    return MedicareGgScoresFromJSONTyped(json, false);
}

export function MedicareGgScoresFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareGgScores {
    if (json == null) {
        return json;
    }
    return {
        
        'eating': json['eating'] == null ? undefined : ((json['eating'] as Array<any>).map(GgFunctionScoreFromJSON)),
        'oral_hygiene': json['oral_hygiene'] == null ? undefined : ((json['oral_hygiene'] as Array<any>).map(GgFunctionScoreFromJSON)),
        'toileting': json['toileting'] == null ? undefined : ((json['toileting'] as Array<any>).map(GgFunctionScoreFromJSON)),
        'bed_mobility': json['bed_mobility'] == null ? undefined : ((json['bed_mobility'] as Array<any>).map(GgFunctionScoreFromJSON)),
        'transfer': json['transfer'] == null ? undefined : ((json['transfer'] as Array<any>).map(GgFunctionScoreFromJSON)),
        'walking': json['walking'] == null ? undefined : ((json['walking'] as Array<any>).map(GgFunctionScoreFromJSON)),
    };
}

export function MedicareGgScoresToJSON(json: any): MedicareGgScores {
    return MedicareGgScoresToJSONTyped(json, false);
}

export function MedicareGgScoresToJSONTyped(value?: MedicareGgScores | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eating': value['eating'] == null ? undefined : ((value['eating'] as Array<any>).map(GgFunctionScoreToJSON)),
        'oral_hygiene': value['oral_hygiene'] == null ? undefined : ((value['oral_hygiene'] as Array<any>).map(GgFunctionScoreToJSON)),
        'toileting': value['toileting'] == null ? undefined : ((value['toileting'] as Array<any>).map(GgFunctionScoreToJSON)),
        'bed_mobility': value['bed_mobility'] == null ? undefined : ((value['bed_mobility'] as Array<any>).map(GgFunctionScoreToJSON)),
        'transfer': value['transfer'] == null ? undefined : ((value['transfer'] as Array<any>).map(GgFunctionScoreToJSON)),
        'walking': value['walking'] == null ? undefined : ((value['walking'] as Array<any>).map(GgFunctionScoreToJSON)),
    };
}

